import { EventEmitter } from './utils/event.emitter';

export abstract class Stream<T extends string = 'close' | 'error'> extends EventEmitter<T> {
  protected started = false;
  private destroyed = false;
  private destroying = false;

  public destroy(error?: string) {
    if (this.isDestroyedOrDestroying()) {
      return;
    }
    this.destroying = true;
    queueMicrotask(() => {
      // allow events concurrent with the call to _destroy() to fire (see #692)
      this.destroyed = true;
      this.destroying = false;
      try {
        this.onDestroy();
      } catch (e) {
        console.error(e);
      }
      if (error) {
        this.emit('error', error);
      }
      this.emit('close', error);
    });
  }

  public isDestroyed() {
    return this.destroyed;
  }

  public isDestroying() {
    return this.destroying;
  }

  public isDestroyedOrDestroying() {
    return this.destroying || this.destroyed;
  }

  protected abstract onDestroy(): void | Promise<void>;
}
